var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-loader",class:{ active: _vm.status }},[_c('img',{attrs:{"src":_vm.assetUrl + '/images/step-loader.gif',"alt":"loader"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }